import { config } from '@config';
import { type TurbosCurrentRpcNode } from '@models/global-setting.model';
import { TurbosSdk } from 'turbos-clmm-sdk';

const cacheRpc = localStorage.getItem('TURBOS_CURRENT_RPC');
let url = cacheRpc ? (JSON.parse(cacheRpc) as TurbosCurrentRpcNode).rpc : undefined;
url = url ? url : config.fullnode ? config.fullnode : undefined;

/** only tokenPocket wallet use;  mainnet  */
const ua = navigator.userAgent;
const isTokenPocket = ua.toLocaleLowerCase().indexOf('tokenpocket') > -1;
const isShinami = url?.toLocaleLowerCase().indexOf('shinami');
url = isTokenPocket && isShinami ? 'https://fullnode.mainnet.sui.io:443' : url;
/** only tokenPocket wallet use;  mainnet  */

export const turbosSdk = new TurbosSdk(config.sui_network, url ? { url: url } : undefined);
export const current_turbos_rpc = url;
